var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBothSort = function SvgBothSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 4.167-4-4-4 4h8ZM8 6.833l-4 4-4-4h8Z",
    fill: "#fff"
  })));
};

export { SvgBothSort as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjExIiB2aWV3Qm94PSIwIDAgOCAxMSIgZmlsbD0ibm9uZSI+CjxwYXRoIGQ9Ik04IDQuMTY2NzVMNCAwLjE2Njc0OEwwIDQuMTY2NzVIOFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik04IDYuODMzNUw0IDEwLjgzMzVMMCA2LjgzMzVIOFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";